<template>
  <div class="tongxin-layout">
    <h1 class="title-with-underline">
      醫師介紹
    </h1>


    <div class="doctor-info">
      <div class="doctor-info__name">葉柏綸醫師</div>

      <img src="@/assets/images/web/tongxin/bg_content_22.png" alt="Doctor illustration" class="img-fluid" />



      <div class="doctor-info__description">
        <div class="doctor-info__description__label">科別</div>
        <div class="doctor-info__description__value">家醫科</div>
      </div>
      <div class="doctor-info__description">
        <div class="doctor-info__description__label">學經歷</div>
        <div class="doctor-info__description__value">國立台灣大學醫學院</div>
      </div>
      <div class="doctor-info__description">
        <div class="doctor-info__description__label">專長</div>
        <div class="doctor-info__description__value">內兒科/肝膽腸胃科/耳鼻喉科/皮膚科/心電圖/肺功能/腹部超音波</div>
      </div>


    </div>



    <div class="fixed-footer-navigation">
      <TongxinNavigation :canProceed="!isLoading" :backButtonIsVisible="true" :nextButtonIsVisible="true"
        textForNextStep="下一步" @back="goBack" @next="handleSubmit" />
    </div>

    <!-- Loading overlay -->
    <div v-if="isLoading" class="loading-overlay">
      <b-spinner style="border-width: 2px" />
    </div>
  </div>
</template>

<script>
import TongxinNavigation from '@/components/web/proj/tongxin/layout/TongxinNavigation.vue'

export default {
  components: {
    TongxinNavigation,
  },
  props: {
    memberId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        idno: '',
        birthday: '',
      },
      errors: {},
      isLoading: false,
    }
  },
  computed: {

  },
  created() {

  },
  methods: {


    handleSubmit() {

    },

    goBack() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss" scoped>
.tongxin-layout {
  padding-bottom: 100px;
}

.doctor-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  &__name {
    font-size: 24px;
    font-weight: bold;
  }

  &__description {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;

    &__label {
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>
